module.exports = __webpack_public_path__ + "static/media/image7_deu.9737b62e.png";